export default __webpack_public_path__ + "static/media/ZinEdu_LOGO.acd2f943.svg";